import FormSelect from 'components/Select/FormSelect';
import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetSubCategoriesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfo } from 'backend/subcategories';

interface IAdditionalDishSubCategorySelect {
	setAdditionalDishSubCategory: (value: Nullable<string>) => void;
	setFetchedAdditionalDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedAdditionalDishCategory: Nullable<string>;
}

const AdditionalDishSubCategorySelect: React.FC<IAdditionalDishSubCategorySelect> = ({
	selectedAdditionalDishCategory,
	setFetchedAdditionalDishSubCategories,
	setAdditionalDishSubCategory,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetSubCategoriesShort, string[]>(
		selectedAdditionalDishCategory ? getSubCategoriesShortInfo : null,
		selectedAdditionalDishCategory ? [selectedAdditionalDishCategory] : [],
	);

	useEffect(() => {
		refetch();
	}, [selectedAdditionalDishCategory]);

	useEffect(() => {
		response && setFetchedAdditionalDishSubCategories(response.data.subCategories);
	}, [response]);

	return (
		<FormSelect
			name="selectedAdditionalDishSubCategory"
			label="subcategoryLabel"
			options={response?.data.subCategories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={!selectedAdditionalDishCategory || loading}
			onChange={setAdditionalDishSubCategory}
		/>
	);
};

export default React.memo(AdditionalDishSubCategorySelect);
